import { ArrowDownBoldHexagonOutlineIcon } from './ArrowDownBoldHexagonOutlineIcon';

/**
 * author: Austin Andrews
 * id 1F47DB52-28B0-40B7-836F-F6F2C58F2412
 * name arrow-down-bold-hexagon-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-bold-hexagon-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomBoldHexagonOutlineIcon = ArrowDownBoldHexagonOutlineIcon;
export default ArrowBottomBoldHexagonOutlineIcon